import React from 'react';
import { Link } from 'react-router-dom';
// import PropTypes from 'prop-types';

import Title from '../partials/Title';
import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/pages/seasons.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
};

const SeasonsPage = ({ page }) => {
    const seasons = page && page.children ? page.children || [] : [];
    return (
        <div className={styles.container}>
            <div className={styles.inner}>
                <Title
                    className={styles.title}
                    seed={`title-${page.id}`}
                    text={page.title}
                    format="normal"
                    borderPosition="bottom"
                />
                <div className={styles.list}>
                    {seasons.map(({ id, title, url }, i) => (
                        <div key={`season-${id}`} className={styles.item}>
                            <Link to={url}>
                                <Title key={`season-${id}-${i + i}`} text={title} format="large" />
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

SeasonsPage.propTypes = propTypes;

export default SeasonsPage;
